import { ICurrencyManager, ICurrencyManagerOptions, TCurrencyAmount, IFormatCurrencyOptions } from "./types";
import { formatCurrency as genericCurrencyFormatter } from "@fortius/prime-ui";
import { getSignupConfig } from "features/signup/configuration";

export class CurrencyManager implements ICurrencyManager {
  code: string;
  locale: string;
  symbol: string;

  private _formatter: typeof genericCurrencyFormatter;
  
  constructor (options?: ICurrencyManagerOptions) {
    const { code, locale, symbol } = options || getSignupConfig().currency;
    
    this.code = code;
    this.locale = locale;
    this.symbol = symbol;
    this._formatter = genericCurrencyFormatter;
  }

  format(amount: TCurrencyAmount, options?: IFormatCurrencyOptions): string {
    return this._formatter(amount, {
      locale: this.locale,
      currency: this.code,
      ...options
    });
  }
}